import React, { useState } from "react";

function Survey(props) {
  const [step, setStep] = useState(0);

  const [student, setStudent] = useState(props.initialAnswers.student);
  const [income, setIncome] = useState(props.initialAnswers.income);
  const [creditScore, setCreditScore] = useState(props.initialAnswers.creditScore);
  const [goal, setGoal] = useState(props.initialAnswers.goal);

  // 🔑 FIX: use maxAnnualFee (number), not boolean
  const [maxAnnualFee, setMaxAnnualFee] = useState(0);

  const steps = [
    {
      title: "Are you a student?",
      value: student,
      setValue: setStudent,
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false }
      ]
    },
    {
      title: "Income",
      value: income,
      setValue: setIncome,
      options: [
        { label: "Under $25k", value: 20000 },
        { label: "$25k–$50k", value: 37500 },
        { label: "$50k–$75k", value: 62500 },
        { label: "$75k+", value: 90000 }
      ]
    },
    {
      title: "Credit Score",
      value: creditScore,
      setValue: setCreditScore,
      options: [
        { label: "No credit", value: 0 },
        { label: "Poor (300–579)", value: 500 },
        { label: "Fair (580–669)", value: 625 },
        { label: "Good (670–739)", value: 705 },
        { label: "Very Good (740–799)", value: 770 },
        { label: "Excellent (800+)", value: 820 }
      ]
    },
    {
      title: "Primary Goal",
      value: goal,
      setValue: setGoal,
      options: [
        { label: "Cash Back", value: "Cash Back" },
        { label: "Travel", value: "Travel" },
        { label: "Everyday Spending", value: "Everyday Spending" },
        { label: "Low Interest", value: "Low Interest" },
        { label: "Balance Transfer", value: "Balance Transfer" },
        { label: "No Preference", value: "No Preference" },
        { label: "Building Credit", value: "Building Credit" }
    
      ]
    },
    {
      title: "Annual Fee Preference",
      value: maxAnnualFee,
      setValue: setMaxAnnualFee,
      options: [
        { label: "No Annual Fee", value: 0 },
        { label: "$0–$50", value: 50 },
        { label: "$51–$100", value: 100 },
        { label: "$101–$150", value: 150 },
        { label: "$151–$200", value: 200 },
        { label: "$201+", value: 1000 }
      ]
    }
    
  ];

  const current = steps[step];

  function canContinue() {
    return current.value !== null && current.value !== undefined;
  }

  function next() {
    if (step < steps.length - 1) setStep(step + 1);
  }

  function back() {
    if (step > 0) setStep(step - 1);
  }

  // 🔑 THIS CREATES THE JSON SENT TO BACKEND
  function submit() {
    const payload = {
      student: student,
      income: income,
      creditScore: creditScore,
      goal: goal,
      maxAnnualFee: maxAnnualFee
    };

    console.log("Submitting payload:", payload); // 👈 DEBUG (keep for now)
    props.onSubmit(payload);
  }

  return (
    <div className="panel fadeIn">
      <div className="surveyTop">
        <div className="progress">
          <div
            className="progressBar"
            style={{ width: ((step + 1) / steps.length) * 100 + "%" }}
          />
        </div>
        <h2>{current.title}</h2>
        <p className="subtle">
          Choose one option. Clickable boxes only.
        </p>
        {props.errorMsg ? <div className="errorBox">{props.errorMsg}</div> : null}
      </div>

      <div className="grid">
        {current.options.map((opt) => {
          const isActive = current.value === opt.value;
          return (
            <button
              key={opt.label}
              className={"choice " + (isActive ? "active" : "")}
              onClick={() => current.setValue(opt.value)}
            >
              {opt.label}
            </button>
          );
        })}
      </div>

      <div className="surveyNav">
        <button className="ghostBtn" onClick={back} disabled={step === 0}>
          Back
        </button>

        {step < steps.length - 1 ? (
          <button className="primaryBtn" onClick={next} disabled={!canContinue()}>
            Continue
          </button>
        ) : (
          <button className="primaryBtn" onClick={submit} disabled={!canContinue()}>
            Get Recommendations
          </button>
        )}
      </div>
    </div>
  );
}

export default Survey;
